module.exports = "/_next/static/images/bd7c00fca6ece7d0f3456ceaab20acca-row-2-with.svg.webp";